import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import AccordionTemplate from "components/accordions/accordion-template/AccordionTemplate";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { useContactInformation } from "hooks/useContactInformation";
import { ROUTES, CARD_FRAGMENTS } from "routes/constants";

const YourPolicyBeneficiaryAccordion = () => {
    const navigate = useNavigateWithSearch();
    const { contactData } = useContactInformation();

    const policyBeneficiaryData = contactData?.policyBeneficiary;

    const handleEdit = () => {
        pushGTMEvent(GA_EVENT_CONFIGS.REVIEW_EDIT_BENEFICIARY);
        navigate(`${ROUTES.APPLICATION.CONTACT}${CARD_FRAGMENTS.POLICY_BENEFICIARY}`);
    };

    return (
        <AccordionTemplate
            title="Your Policy Beneficiary"
            accordionName="your-review-information"
            onEdit={handleEdit}
            dataTestId="your-policy-beneficiary-accordion"
        >
            <div className="flex justify-between pr-6 mb-4">
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">First Name</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">{policyBeneficiaryData?.firstName}</p>
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Relationship</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">
                            {policyBeneficiaryData?.relationship?.replace(/([a-z])([A-Z])/g, "$1 $2")}
                        </p>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Last Name</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">{policyBeneficiaryData?.lastName}</p>
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Benefit Percentage</p>
                        <p className="text-base-content text-sm font-medium">100%</p>
                    </div>
                </div>
            </div>
        </AccordionTemplate>
    );
};

export default YourPolicyBeneficiaryAccordion;
